"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundEffect = void 0;
var SoundEffect;
(function (SoundEffect) {
    SoundEffect["CombatBlockArmor"] = "combat-block-armor";
    SoundEffect["CombatBlockWeapon"] = "combat-block-weapon";
    SoundEffect["CombatDie"] = "combat-die";
    SoundEffect["CombatHitMelee"] = "combat-hit-melee";
    SoundEffect["CombatHitSpell"] = "combat-hit-spell";
    SoundEffect["CombatKill"] = "combat-kill";
    SoundEffect["CombatMiss"] = "combat-miss";
    SoundEffect["CombatSpecialBlunderbuss"] = "combat-special-blunderbuss";
    SoundEffect["EnvDoorClose"] = "env-door-close";
    SoundEffect["EnvDoorOpen"] = "env-door-open";
    SoundEffect["EnvStairs"] = "env-stairs";
    SoundEffect["MonsterBear"] = "monster-bear";
    SoundEffect["MonsterBird"] = "monster-bird";
    SoundEffect["MonsterDragon"] = "monster-dragon";
    SoundEffect["MonsterGhost"] = "monster-ghost";
    SoundEffect["MonsterGoblin"] = "monster-goblin";
    SoundEffect["MonsterRocks"] = "monster-rocks";
    SoundEffect["MonsterSkeleton"] = "monster-skeleton";
    SoundEffect["MonsterTurkey"] = "monster-turkey";
    SoundEffect["MonsterWolf"] = "monster-wolf";
    SoundEffect["SpellAOEFire"] = "spell-aoe-fire";
    SoundEffect["SpellAOEFrost"] = "spell-aoe-frost";
    SoundEffect["SpellAOELightning"] = "spell-aoe-lightning";
    SoundEffect["SpellBuffMagical"] = "spell-buff-magical";
    SoundEffect["SpellBuff"] = "spell-buff";
    SoundEffect["SpellBuffPhysical"] = "spell-buff-physical";
    SoundEffect["SpellBuffProtection"] = "spell-buff-protection";
    SoundEffect["SpellConjure"] = "spell-conjure";
    SoundEffect["SpellDebuffGive"] = "spell-debuff-give";
    SoundEffect["SpellDebuffReceive"] = "spell-debuff-receive";
    SoundEffect["SpellHeal"] = "spell-heal";
    SoundEffect["SpellSightEffect"] = "spell-sight-effect";
    SoundEffect["SpellSpecialBerserk"] = "spell-special-berserk";
    SoundEffect["SpellSpecialRevive"] = "spell-special-revive";
    SoundEffect["SpellSpecialTeleport"] = "spell-special-teleport";
})(SoundEffect || (exports.SoundEffect = SoundEffect = {}));
